import { createSlice, createAsyncThunk } from '@reduxjs/toolkit'
import { fetchCaseLists } from '../../../utilities/API/caseServices';
import moment from 'moment';

export const caseListDetails = createAsyncThunk(
    'case/listsData', fetchCaseLists
)


const initialState = {
    caseList: [{
        program: "--",
        "subStatus": "--",
        "PortalAppStatus": "--",
        "PatientSSN": "--",
        "PatientAlienNumber": "--",
        "pointOfContactName": "--",
        "PatientFullName": "--",
        "PatientID": "--",
        "IDNumber": "--",
        "pxCreateDateTime": "--",
        "caseNumber": "--",
        "applicationID": "--",
        "PatientDOB": "--"
    }]
}

const caseListSlice = createSlice({
    name: 'caseListData',
    initialState,

    reducers: {
        resetCaseLists: (state) => {
            state.caseList = [{
                program: "--",
                "subStatus": "--",
                "PortalAppStatus": "--",
                "PatientSSN": "--",
                "PatientAlienNumber": "--",
                "pointOfContactName": "--",
                "PatientFullName": "--",
                "PatientID": "--",
                "IDNumber": "--",
                "pxCreateDateTime": "--",
                "caseNumber": "--",
                "applicationID": "--",
                "PatientDOB": "--"
            }]
        }
    },
    extraReducers: (builder) => {
        builder
            .addCase(caseListDetails.pending, (state, action) => {
            })
            .addCase(caseListDetails.fulfilled, (state, action) => {
                const arr = []
                if (action.payload.status == "SUCCESS" && action?.payload?.data?.length > 0) {
                    action?.payload?.data?.map((data) => {
                        arr.push({
                            "program": "CASE",
                            "subStatus": data?.substatus || "--",
                            "PortalAppStatus": data?.status || "--",
                            "SSNorANumber": data?.ssnoranumber || "--",
                            "PatientSSN": (data?.idnumber != null && data?.idnumber[0] != "A" && data?.idnumber[0] != "a") ? data?.idnumber?.replace(/^(\d{3})(\d{2})(\d{4})$/, "$1-$2-$3") : "--",
                            "PatientAlienNumber": (data?.idnumber != null && (data?.idnumber[0] == "A" || data?.idnumber[0] == "a")) ? data?.idnumber : "--",
                            "pointOfContactName": data?.pointofcontactname || "--",
                            "PatientFullName": data?.patientname || "--",
                            "PatientID": data?.patientid || "--",
                            "IDNumber": data?.idnumber || "--",
                            "pxCreateDateTime": data?.createddate != "" ? moment(data?.createddate).format('ll') : "--",
                            "caseNumber": data?.casenumber || "--",
                            "applicationID": data?.caseid || "--",
                            "PatientDOB": data?.birthdate || "--",
                            "caseOwner": data?.caseowner
                        })
                    })
                    state.caseList = arr
                }
            })
            .addCase(caseListDetails.rejected, (state, action) => {
            })
    },
})

export const { resetCaseLists } = caseListSlice.actions;

export default caseListSlice.reducer
